export const ACTIONS = {
  SELECT_MODEL_PORTFOLIO: 'SELECT_MODEL_PORTFOLIO',
  CONFIRM_MODEL_PORTFOLIO: 'CONFIRM_MODEL_PORTFOLIO',
  RESET: 'RESET',
  SET_SELECTED_ASSETS: 'SET_SELECTED_ASSETS',
  SET_ACTIVE_ASSETS: 'SET_ACTIVE_ASSETS',
  TOGGLE_ASSET: 'TOGGLE_ASSET',
  TOGGLE_ACTIVE_ASSET: 'TOGGLE_ACTIVE_ASSET',
};

export const STEPS = {
  SELECT: 'SELECT',
  INSTRUMENTS: 'INSTRUMENTS',
  REVIEW: 'REVIEW',
};
